// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daterangepicker .cancelBtn {
    display: none !important;
}

.daterangepicker td.active.start-date {
    background-color: #83a4cf !important;
    color: white !important;
    /* border-radius: 50% !important; */
}

/* Highlight end date */
.daterangepicker td.active.end-date {
    background-color: #83a4cf !important;
    color: white !important;
    /* border-radius: 50% !important; */
}

/* Optional: remove in-range background color */
/* .daterangepicker td.in-range {
    background-color: transparent !important;
} */

.daterangepicker .applyBtn {
    background-color: #83a4cf !important;
    /* Change to any color you like */
    color: white !important;
    border: none !important;
    border-radius: 4px;
    padding: 6px 12px;
}

/* Optional: hover effect */
.daterangepicker .applyBtn:hover {
    background-color: #83a4cf !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MileageSarathiTab_bus/Filter/styles.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA,uBAAuB;AACvB;IACI,oCAAoC;IACpC,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA,+CAA+C;AAC/C;;GAEG;;AAEH;IACI,oCAAoC;IACpC,iCAAiC;IACjC,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,oCAAoC;AACxC","sourcesContent":[".daterangepicker .cancelBtn {\n    display: none !important;\n}\n\n.daterangepicker td.active.start-date {\n    background-color: #83a4cf !important;\n    color: white !important;\n    /* border-radius: 50% !important; */\n}\n\n/* Highlight end date */\n.daterangepicker td.active.end-date {\n    background-color: #83a4cf !important;\n    color: white !important;\n    /* border-radius: 50% !important; */\n}\n\n/* Optional: remove in-range background color */\n/* .daterangepicker td.in-range {\n    background-color: transparent !important;\n} */\n\n.daterangepicker .applyBtn {\n    background-color: #83a4cf !important;\n    /* Change to any color you like */\n    color: white !important;\n    border: none !important;\n    border-radius: 4px;\n    padding: 6px 12px;\n}\n\n/* Optional: hover effect */\n.daterangepicker .applyBtn:hover {\n    background-color: #83a4cf !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
